const isNativeFetch = /function\s?(fetch)?\s?\(\)\s?{\s*\[native code\]\s*}/g;
function createNativeFetch() {
    var _a, _b;
    const frame = globalThis.document.createElement('iframe');
    frame.style.display = 'none';
    globalThis.document.body.append(frame);
    const fn = (_b = (_a = frame.contentWindow) === null || _a === void 0 ? void 0 : _a.fetch) === null || _b === void 0 ? void 0 : _b.bind(globalThis);
    globalThis.document.body.removeChild(frame);
    return fn;
}
export function getNativeFetch() {
    var _a;
    return isNativeFetch.test(globalThis.fetch.toString()) ? globalThis.fetch : (_a = createNativeFetch()) !== null && _a !== void 0 ? _a : globalThis.fetch;
}
